// Pointer-gesture helpers. Pure functions; no DOM side effects.
//
// The flick direction is the dominant axis of the pointer delta, provided
// the larger component exceeds FLICK_THRESHOLD_PX. Below threshold returns
// null and the controller treats it as a no-op (tap).

import { FLICK_THRESHOLD_PX, type Direction } from './state'

export function resolveDirection(dx: number, dy: number): Direction | null {
  const absX = Math.abs(dx)
  const absY = Math.abs(dy)
  if (Math.max(absX, absY) < FLICK_THRESHOLD_PX) {
    return null
  }
  if (absX > absY) {
    return dx > 0 ? 'RIGHT' : 'LEFT'
  }
  return dy > 0 ? 'DOWN' : 'UP'
}
